import { createSelector } from 'reselect';
import { isDynamicStep } from './state.js';

/**
 * Selectors for prop forwarding
 */ const stateProp = (s)=>s
;
const configuratorIdProp = (_, { id  })=>id
;
const stepNameProp = (_, { stepName  })=>stepName
;
const stepsMapProp = (_, { stepsMap  })=>stepsMap
;
const stepSequenceProp = (_, { stepSequence  })=>stepSequence
;
const getConfigurators = (state)=>state.configurators
;
const getConfigurator = createSelector(getConfigurators, configuratorIdProp, (configurators, id)=>configurators[id]
);
/**
 * Step related selectors
 */ const getStepSequence = createSelector(getConfigurator, (c)=>{
    return c === null || c === void 0 ? void 0 : c.stepSequence;
});
const getCurrentStepNumber = createSelector(getConfigurator, (c)=>{
    return c === null || c === void 0 ? void 0 : c.currentStep;
});
const getStepsVisited = createSelector(getConfigurator, (c)=>{
    return c === null || c === void 0 ? void 0 : c.stepsVisited;
});
const getStepsList = createSelector(stepsMapProp, stepSequenceProp, getCurrentStepNumber, (s)=>s
, (stepsMap, stepSequence, currentStepNumber, s)=>(stepSequence || []).reduce((acc, stepName, i)=>{
        let stepStatus = 'active';
        if (!stepsMap) {
            return [];
        }
        const step = stepsMap[stepName];
        if (!step) {
            return acc;
        }
        if (isDynamicStep(step)) {
            stepStatus = step.stepStatus(s);
            if (stepStatus === 'hidden') {
                return acc;
            }
        }
        return [
            ...acc,
            {
                name: stepName,
                isCurrent: currentStepNumber === i,
                skip: stepStatus === 'skip',
                isSubStep: stepStatus === 'sub-step'
            }, 
        ];
    }, [])
);
const getActiveSteps = createSelector(getStepsList, (steps)=>(steps || []).filter((s)=>!s.skip
    )
);
const getCurrentStepIndex = createSelector(getStepsList, (steps)=>{
    const index = steps.findIndex((s)=>s.isCurrent
    );
    return index < 0 ? undefined : index;
});
const getCurrentStepName = createSelector(getStepsList, (steps)=>{
    var ref;
    return (ref = steps.find((s)=>s.isCurrent
    )) === null || ref === void 0 ? void 0 : ref.name;
});

export { configuratorIdProp, getActiveSteps, getConfigurator, getConfigurators, getCurrentStepIndex, getCurrentStepName, getCurrentStepNumber, getStepSequence, getStepsList, getStepsVisited, stateProp, stepNameProp, stepSequenceProp, stepsMapProp };
//# sourceMappingURL=selectors.internal.js.map
